// extracted by mini-css-extract-plugin
module.exports = {"svgWrapper":"SunIcon_svgWrapper__1Rebi","svg":"SunIcon_svg__3ki9s"};